// extracted by mini-css-extract-plugin
module.exports = {"cookiesAndPolicy":"FooterBlippAdminInfo_cookiesAndPolicy__t0m8U","orgNumberAndCopyright":"FooterBlippAdminInfo_orgNumberAndCopyright__VEUwr"};